import { Dispatch } from "redux";
import { AppStateWithData } from "../../..";
import { ApiConfig } from "../../../../config";
import { createRequestActionTypes, createRequestThunk, RequestThunkParameters } from "../../../../utils";
import { processGetPredecessorsResponse } from "./proccessPredecessors";


export interface GetPredecessorsAdditionalData {
    docId: string,
}

export const getPredecessorsForDocumentActionTypes = createRequestActionTypes('GET_PREDECESSORS_FOR_DOCUMENT')

export const getPredecessorsForDocument = (config: ApiConfig) => (docId: string) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<string[], never, GetPredecessorsAdditionalData> = {
        method: 'GET',
        requestActionTypes: getPredecessorsForDocumentActionTypes,
        url: `${config.API_URL}/gantt/predecessors?docId=${docId}`,
        actionAdditionalData: {
            docId
        },
        processResultBeforeDispatch: processGetPredecessorsResponse
    }

    return dispatch<any>(createRequestThunk(thunkParams))
}